import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import MUILink from '@material-ui/core/Link';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import { Link } from "react-router-dom";
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

export default function PaymentSuccess(props) {

    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent style={{ paddingTop: '10px' }}>
                <DialogActions style={{ paddingTop: 0 }}>
                    <IconButton onClick={props.handleClose} color="primary"><CloseIcon /></IconButton>
                </DialogActions>

                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <video src="/vid/cardsuccess.webm" muted preload autoPlay={true} height="300" />
                </div>
                <div>
                    <Typography variant="h4" style={{ textAlign: 'center', fontWeight: '500', marginTop: '20px' }}>Thank you!</Typography>
                    <Typography variant="body1" style={{ textAlign: 'center', fontWeight: '400', marginTop: '10px', padding: '10px' }}>
                        Thanks to you we can keep the lights on and continue our mission of making 3D accessible to everyone. Cheers!
                    </Typography>

                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', margin: '10px'}}>
                        <Button variant="contained"
                            color="primary"
                            size="large"
                            style={{ textTransform: 'none', marginBottom: '10px' }}
                            endIcon={<ArrowForwardIcon />}
                            href="https://docs.google.com/forms/d/e/1FAIpQLSf8UrNvEjBHugsYCUpa3B7czmepNcTKR3wQgpXojLqemsQ_4g/viewform"
                            target="_blank"
                        //component={a}
                        >Choose our next goal</Button>

                        <Button variant="contained"
                            color="primary"
                            size="large"
                            style={{ textTransform: 'none' }}
                            endIcon={<ArrowForwardIcon />}
                            href="https://discord.gg/zRauP2Za9J"
                            target="_blank"
                        >Get discord access</Button>

                    </div>

                    <MUILink href="https://lottiefiles.com/9912-payment-success" target="_blank" rel="noopener" >
                        <Typography variant="body2" color="textSecondary" style={{ textAlign: 'center', fontWeight: '400', marginTop: '20px' }}>Animation by Mohamed Wisam, CC-BY</Typography>
                    </MUILink>

                </div>

            </DialogContent>
        </Dialog>
    );
}